import { store } from "./../Redux/app/store";
import { GET_TOKEN_SYSTEM } from "./../shared/constants";

export const JWT_HEADER = (formUrlencoded = false) => {
  let config = {
    headers: {
      Authorization: "",
      "Access-Control-Allow-Origin": "*",
      "allow-origin": "*",
    },
  };

  if (GET_TOKEN_SYSTEM())
    config.headers.Authorization = `Bearer ${GET_TOKEN_SYSTEM()}`;

  if (formUrlencoded)
    config.headers = {
      "content-type": "application/x-www-form-urlencoded",
    };

  return config;
}

export const CREATE_AUTH_HEADER = (name_token) => {
  const token = localStorage.getItem(name_token);
  return {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      "Access-Control-Allow-Origin": "*",
      "allow-origin": "*",
    }
  };
};

export const GET_TOKEN_LOCAL_STORAGE = (name_token) => localStorage.getItem(name_token);

export const PermissionValidatorFunction = (permissions, allPermissions = true) => {
  const state = store.getState(); // Obtiene el estado desde redux 
  const currentPermissions = state.permissionsSlice.permissions; // Obtiene los permisos desde redux
  return allPermissions
    ? permissions.every((p) => currentPermissions?.includes(p))
    : permissions.some((p) => currentPermissions?.includes(p));
};

export function search(rows, searchQuery) {
  //constantes para busqueda de todas las columnas
  const columns = rows[0] && Object.keys(rows[0]);
  return rows.filter((row) =>
    columns.some(
      (column) =>
        row[column].toString().toLowerCase().indexOf(searchQuery.toLowerCase()) > -1))
}

export const isObjectEmpty = (objectName) => {
  return !objectName || Object.keys(objectName)?.length === 0
}

export const isInteger = (value) => {
  const num = parseInt(value, 10);
  return Number.isFinite(num) && String(num) === String(value);
}

export const limpiarNombreArchivo = (nombre) => {
  // Eliminar espacios al principio y al final
  nombre = nombre.trim();
  // Reemplazar todo lo que no sea letras (incluyendo acentos) ni números
  const nombreLimpio = nombre.replace(/[^A-Za-z0-9áéíóúÁÉÍÓÚüÜñÑ]/g, '_');
  return nombreLimpio;
}